<script lang="ts">
    import { fade } from "svelte/transition";
    import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
    import type { Message } from "../../Stores/TypeMessageStore/MessageStore";
    import { textMessageStore } from "../../Stores/TypeMessageStore/TextMessageStore";
    import ButtonClose from "../Input/ButtonClose.svelte";

    interface Props {
        /* eslint-disable svelte/no-at-html-tags */
        message: Message;
    }

    let { message }: Props = $props();

    let content = $derived(JSON.parse(message.text));
    let converter = $derived(new QuillDeltaToHtmlConverter(content.ops, { inlineStyles: true }));

    function closeTextMessage() {
        textMessageStore.clearMessageById(message.id);
    }

    function onKeyDown(e: KeyboardEvent) {
        if (e.key === "Escape") {
            closeTextMessage();
        }
    }
</script>

<svelte:window onkeydown={onKeyDown} />

<div
    class="main-text-message pointer-events-auto z-[800] flex max-h-64 w-3/5 gap-3 rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] py-3 pr-2 pl-5 text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)] animate-bounce-in"
    out:fade={{ duration: 150 }}
>
    <div class="icon mt-3 text-xl text-[var(--nutrivera-shell-accent)]">💬</div>
    <div
        class="content-text-message mr-6 flex max-h-60 w-full overflow-auto text-[var(--nutrivera-shell-text)]"
    >
        {@html converter.convert()}
    </div>
    <ButtonClose onclick={closeTextMessage} />
</div>

<style>
    @keyframes bounce-in {
        0% {
            transform: scale(0.5);
            opacity: 0;
        }
        60% {
            transform: scale(1.05);
            opacity: 1;
        }
        100% {
            transform: scale(1);
        }
    }
    .animate-bounce-in {
        animation: bounce-in 0.5s ease-out;
    }
</style>
